import React, { useState, useEffect } from 'react';

const ModalEditarHora = ({ show, handleClose, horaEditando, handleSave }) => {
  const [nuevaHora, setNuevaHora] = useState('');
  const [segmento, setSegmento] = useState(1); 
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (horaEditando) {
      setNuevaHora(horaEditando.horaActual || '');
      setSegmento(horaEditando.segmento || 1);
    }
  }, [horaEditando]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!nuevaHora) return;
    
    handleSave({
      ...horaEditando,
      horaActual: nuevaHora,
      segmento: segmento
    });
  };

  if (!show) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Editar Hora {horaEditando.tipo === 'E' ? 'de Entrada' : 'de Salida'}
            </h5>
            <button type="button" className="btn-close" onClick={handleClose}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Hora:</label>
                <input
                  type="time"
                  className="form-control"
                  value={nuevaHora}
                  onChange={(e) => setNuevaHora(e.target.value)}
                  required
                />
              </div> 
              {/*
              <div className="mb-3">
                <label className="form-label">Segmento:</label>
                <input
                  type="number"
                  className="form-control"
                  value={segmento}
                  onChange={(e) => setSegmento(parseInt(e.target.value))}
                  min="1"
                  required
                />
              </div> 
              */}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={handleClose}>
                Cancelar
              </button>
             
             <button 
                    type="submit" 
                    className="btn btn-primary"
                    disabled={loading}
                    >
                    {loading ? (
                        <>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Guardando...
                        </>
                    ) : 'Guardar Cambios'}
            </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ModalEditarHora;